import { useBreakpoints } from '@/core/hooks/useBreakpoints/useBreakpoints'
import { TTheme, useCustomTheme } from '@/core/theme'
import SvgLogo from '@/ui/components/svg/logo'
import SvgInvite from '@assets/images/invite.svg?react'
import {
    Footer,
    InviteIconWrapper,
    Left,
    NewInvitationPageWrapper,
    Right,
    SignInButton,
    StyledConfettiExplosion,
} from './newInvitationPage.styles'
import { NotInvitedContent } from './notInvitedContent'
import Typography from '@/ui/components/typography'
import { useRouting } from '@/core/hooks/useRouting'

const NewInvitationPage = () => {
    const { navigateTo, ROUTES } = useRouting()
    const theme = useCustomTheme() as TTheme
    const [isInvited, setIsInvited] = useState(false)
    const { width, height, aboveBreakpoint, belowBreakpoint } = useBreakpoints()

    const handleSignInButtonClick = () => {
        navigateTo({
            path: ROUTES.summary.path,
            event: {
                name: 'SEM::navigate_to_summary_page',
                params: {
                    origin: 'new_invitation_page',
                },
            },
        })
    }

    return (
        <NewInvitationPageWrapper>
            {aboveBreakpoint('sm') && (
                <Left>
                    <SvgLogo
                        primaryColor={theme.colors.greys[0]}
                        secondaryColor={theme.colors.primary[200]}
                    />
                    <InviteIconWrapper>
                        <SvgInvite color={theme.colors.semantic.separator} />
                    </InviteIconWrapper>
                </Left>
            )}
            <Right>
                {belowBreakpoint('sm') && (
                    <div className="logo">
                        <SvgLogo
                            primaryColor={theme.colors.greys[800]}
                            secondaryColor={
                                theme.colors.semantic
                                    .sendNewInvitationBackground
                            }
                        />
                    </div>
                )}
                <div className="send-an-invitation">
                    <Typography className="stance" variant="xs-bold">
                        At-Bay Stance
                    </Typography>
                    {!isInvited ? (
                        <NotInvitedContent setIsInvited={setIsInvited} />
                    ) : (
                        <>
                            <Typography
                                className="invited-title"
                                variant="xxl-regular"
                                noWrap={false}
                                testId="invited-title"
                            >
                                Thank You for Signing Up!
                            </Typography>
                            {isInvited && (
                                <StyledConfettiExplosion
                                    duration={3000}
                                    particleCount={200}
                                    colors={[
                                        theme.colors.primary[600],
                                        theme.colors.yellows[900],
                                        theme.colors.teals[800],
                                    ]}
                                    width={
                                        belowBreakpoint('md')
                                            ? width * 2
                                            : width * 1.2
                                    }
                                    height={height}
                                />
                            )}
                            <Typography variant="xs-regular">
                                Check your inbox.
                            </Typography>
                            <Typography variant="xs-regular" noWrap={false}>
                                If you're eligible, you'll receive an invite to
                                start using Stance soon.
                            </Typography>
                        </>
                    )}
                    <Footer>
                        <Typography variant="xs-regular" noWrap={false}>
                            Already have an At-Bay Stance account?
                        </Typography>
                        <SignInButton
                            variant="xs-bold"
                            testId="sign-in-button"
                            onClick={handleSignInButtonClick}
                        >
                            Sign in here ›
                        </SignInButton>
                    </Footer>
                </div>
            </Right>
        </NewInvitationPageWrapper>
    )
}

export default NewInvitationPage
